
var originalRender = fabric.IText.prototype._render;
fabric.IText.prototype._render = function (ctx) {
    originalRender.call(this, ctx);
    //Don't draw border if it is active(selected/ editing mode)
    if (this.active) return;

    var w = this.width,
        h = this.height,
        x = -this.width / 2,
        y = -this.height / 2;
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x + w, y);
    ctx.lineTo(x + w, y + h);
    ctx.lineTo(x, y + h);
    ctx.lineTo(x, y);
    ctx.closePath();
    var stroke = ctx.strokeStyle;
    ctx.strokeStyle = this.textboxBorderColor;
    ctx.stroke();
    ctx.strokeStyle = stroke;
}
fabric.IText.prototype.cacheProperties = fabric.IText.prototype.cacheProperties.concat('active');


